import api from './api';

export const friendshipApi = {
  sendFriendRequest: async (addresseeId) => {
    return await api.post('/friendships', { addressee_id: addresseeId });
  },

  getFriendships: async () => {
    return await api.get('/friendships');
  },

  getFriends: async () => {
    return await api.get('/friendships/friends');
  },

  getSuggestions: async (limit = 10) => {
    return await api.get(`/friendships/suggestions?limit=${limit}`);
  },

  acceptFriendRequest: async (id) => {
    return await api.put(`/friendships/${id}/accept`);
  },

  deleteFriendship: async (id) => {
    return await api.delete(`/friendships/${id}`);
  },
};
